import {ContainerEntity} from "@ots-frontend/ots-data";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";
import {useCallback} from "react";

export type BaseContainerMultiSelectProps = Omit<
  BaseEntityMultiSelectProps<ContainerEntity>,
  'nameMapper'
> & {
  useAbbreviation?: boolean;
};

export const BaseContainerMultiSelect = (props: BaseContainerMultiSelectProps) => {
  const {useAbbreviation = false, ...rest} = props;

  const nameMapper = useCallback((e: ContainerEntity) => {
    return useAbbreviation ? (e.abbr ?? e.name) : e.name;
  }, [useAbbreviation]);

  return <BaseEntityMultiSelect nameMapper={nameMapper} {...rest} />;
};
